var map = {
	"./animate.js": 81,
	"./cookie.js": 82,
	"./extra-content.js": 83,
	"./general.js": 84,
	"./glide.js": 94,
	"./layered-content.js": 95,
	"./legacy.js": 96,
	"./navbar.js": 100,
	"./polyfill.js": 104,
	"./resize.js": 105,
	"./scroll.js": 106,
	"./tabs.js": 107,
	"./team.js": 108,
	"./typography.js": 109,
	"./video.js": 110
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 80;